import React from 'react';
import { Dialog, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from '../../../../theme/Modals';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { UPDATE_L7_RESOURCE } from '../../../../actions/update';
import {Typography} from "@/elements";

const ModalSwitchOnResource = ({
  show,
  hideModal,
  l7ResourceId,
  name,
  query,
  getVariables,
  partnerClientAccountId,
}) => {
  const classes = useStyles();

  const [updateL7Resource] = useMutation(UPDATE_L7_RESOURCE);

  const onClickOnResource = () => {
    updateL7Resource({
      variables: {
        serviceEnable: 1,
        partnerClientAccountId: Number(partnerClientAccountId),
        serviceId: Number(l7ResourceId), // используется l7ResourceId, т.к. l7ResourceId === serviceId, и для общей таблицы нету фильтрации по полю serviceId
      },
      refetchQueries: [{ query: query, variables: getVariables() }],
    })
      .then(() => toast.success('Success'))
      .catch((err) => toast.error(err.message));
    hideModal();
  };

  return (
    <div>
      <Dialog
        className={classes.dialog}
        maxWidth="md"
        open={show}
        onClose={() => {
          hideModal();
        }}
      >
        <div className={classes.modal}>
          <div className={classes.header}>
            <Typography isNoWrap={false} variant="h6">Switch on resource</Typography>
            <Button className={classes.close} onClick={() => hideModal()}>
              <CloseIcon />
            </Button>
          </div>
          <div className={classes.modalBody}>
            <div className={classes.dsc}>
              Are you sure that you want to activate the resource <strong>ID {l7ResourceId} ({name})</strong>?
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button className={classes.cancel} onClick={() => hideModal()}>
              Cancel
            </Button>
            <Button className={classes.delete} onClick={onClickOnResource}>
              activate
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalSwitchOnResource;
